import React from 'react'
import { Input, InputAdornment, Box } from '@mui/material'
import SearchIcon from '@mui/icons-material/Search'
import useStyles from './styles'
import { withTranslation, useTranslation } from 'react-i18next'

function SearchBar(props) {
  const { t } = useTranslation()
  const classes = useStyles()

  return (
    <Box className={classes.container}>
      <Input
        placeholder={props.placeholder || t('Search')}
        onChange={props.onChange}
        value={props.value}
        sx={{
          backgroundColor: 'common.white',
          border: '1px solid',
          borderColor: 'divider',
          width: 260,
          height: 40,
          maxWidth: '100%',
          fontSize: 14,
          color: 'text.primary',
          padding: '0 15px',
          borderRadius: '10px',
          transition: 'border-color .15s ease, box-shadow .15s ease',
          '&:hover': { borderColor: 'grey.400' },
          '&.Mui-focused': {
            borderColor: 'primary.main',
            boxShadow: '0 0 0 3px rgba(244, 102, 31, 0.14)'
          }
        }}
        startAdornment={
          <InputAdornment position="start" sx={{ mr: 1 }}>
            <SearchIcon sx={{ color: 'grey.500', fontSize: 18 }} />
          </InputAdornment>
        }
        disableUnderline
        id="basic-input"
      />
    </Box>
  )
}

export default withTranslation()(SearchBar)
